import { TKey } from '~/src/dash/publicaUI';

export type BidErrorKey =
  | 'BidUndefined'
  | 'BidTimeoutError'
  | 'BidBadInputError'
  | 'BidBadServerResponseError'
  | 'BidFailedToRequestBidsError'
  | 'BidAuctionFailed'
  | 'BidRateLimitBlocked'
  | 'BidFailedToParseResponse'
  | 'BidConnectionError'
  | 'BidPanic'
  | 'BidPrebidError'
  | 'BidEmptyResponseError'
  | 'BidNoContent204Error'
  | 'BidNoFillError'
  | 'BidEmptyVastError'
  | 'BidVastValidateError'
  | 'BidCachePutCacheMiss'
  | 'BidUnwrapTimeoutError'
  | 'BidPriceBelowFloor'
  | 'BidUnknownError'
  | 'BidRejectedUnknown'
  | 'BidRejectedDuration'
  | 'BidRejectedDupMediafileUrl'
  | 'BidRejectedDupAdomain'
  | 'BidRejectedDupCategory'
  | 'BidRejectedCacheId'
  | 'BidRejectedPrice'
  | 'BidRejectedAdvertiserBlocklist'
  | 'BidRejectedIabCatBlocklist'
  | 'BidRejectedAdomainMissing'
  | 'BidRejectedAboveMaxAdDuration'
  | 'BidRejectedBelowMinAdDuration'
  | 'BidNoMediafileSatisfySiteMaxBitrate'
  | 'BidRejectedPodFloor'
  | 'BidRejectedAllHouseAds'
  | 'BidRejectedDupAdId'
  | 'BidRejectedDupCreativeId'
  | 'BidNoMediafileSatisfyEndpointMaxBitrate'
  | 'BidNoMediafileSatisfyEndpointMinBitrate'
  | 'BidNoMediafileSatisfySiteMinBitrate'
  | 'BidRejectedBrandSafetyRuleBlock'
  | 'BidRejectedMinPodSizeNotMeet'
  | 'BidRejectedDupBidCatExclusion'
  | 'BidRejectedTooManyBidCatExclusion'
  | 'BidPriceMissing'
  | 'BidBidderNotSharedInventory'
  | 'BidRejectedDupAdomainElea'
  | 'BidRejectedDupAdomainClickThrough'
  | 'BidRejectedDupCategoryElea'
  | 'BidRejectedPriceAboveErrorThreshold'
  | 'BidRejectedDupCampaignId'
  | 'BidRejectedDupApsKey'
  | 'BidRejectedMediafileBlocklist'
  | 'BidRejectedNotFirstSlotInPod'
  | 'BidRejectedDupMediafileUrlNormal'
  | 'BidRejectedCreativeIdBlock'
  | 'BidRejectedNonsecureVast'
  | 'BidRejectedSlotTargetingMismatch'
  | 'BidInvalidRequestUrl'
  | 'BidRejectedCreativeBlockUnknown'
  | 'BidRejectedCreativeBlock404NotFound'
  | 'BidRejectedCreativeBlockMismatchDuration'
  | 'BidRejectedCreativeValidationRejected'
  | 'BidRejectedOverOrderFrequencyCap'
  | 'BidRejectedOverCampaignFrequencyCap'
  | 'BidSiteLoopError'
  | 'BidRejectedBlockedByAdvertiser'
  | 'BidRejectedAboveSharedPodDuration'
  | 'BidRejectedTier'
  | 'BidMaxUnwrapError'
  | 'BidRejectedLanguageBlocklist'
  | 'BidMissingVastMeta'
  | 'BidXmlSyntaxError'
  | 'BidRejectedAdvertiserRuleDoNotAir'
  | 'BidRejectedAdvertiserRuleCompetitiveSeparationSelf'
  | 'BidRejectedAdvertiserRuleCompetitiveSeparationOther'
  | 'BidRejectedDupPhiloAudioIdent'
  | 'BidInvalidMediafileDeliveryType'
  | 'BidRejectedCategoryExclusivity'
  | 'BidUnwrapEOFError'
  | 'BidRejectedCacheConnection'
  | 'BidRejectedCacheXmlEncode'
  | 'BidRejectedCacheStore'
  | 'BidConnectionErrorAlt'
  | 'BidRejectedEventTrackerBlocklist'
  | 'BidPriceTooHigh'
  | 'BidRejectedCreativeQualityAssurance'
  | 'BidRejectedPlatformConnectionBidderSlotTargetingMismatch'
  | 'BidRejectedBelowFloor'
  | 'BidCombineCreativeError'
  | 'BidResponseEofError'
  | 'BidConnectionResetByPeer'
  | 'BidGzipReadError'
  | 'BidUnwrapParseError'
  | 'BidMacroReplacementError'
  | 'BidOtherUnwrapError'
  | 'BidRejectedPrivateAuctionDealIDMismatch';

export type CampaignNoFillErrorKey =
  | 'NoFillUndefined'
  | 'EmptyVast'
  | 'FrequencyCap'
  | 'Pacing'
  | 'SiteLoopError'
  | 'EmptyVastMediafile'
  | 'CreativeSelectionError'
  | 'ZeroDuration'
  | 'AdserverOrderNotFound'
  | 'LowPacing'
  | 'OrderFrequencyCap'
  | 'VastTimeout'
  | 'EmaPacing'
  | 'EmaPacingDataNotFound';

export const bidErrorKeyToTKeyMap: Record<BidErrorKey, TKey> = {
  BidUndefined: 'BidErrorCodeUndefined',
  BidTimeoutError: 'BidErrorCodeTimeoutError',
  BidBadInputError: 'BidErrorCodeBadInputError',
  BidBadServerResponseError: 'BidErrorCodeBadServerResponseError',
  BidFailedToRequestBidsError: 'BidErrorCodeFailedToRequestBidsError',
  BidAuctionFailed: 'BidErrorCodeBidAuctionFailed',
  BidRateLimitBlocked: 'BidErrorCodeRateLimitBlocked',
  BidFailedToParseResponse: 'BidErrorCodeFailedToParseResponse',
  BidConnectionError: 'BidErrorCodeConnectionError',
  BidPanic: 'BidErrorCodePanic',
  BidPrebidError: 'BidErrorCodePrebidError',
  BidEmptyResponseError: 'BidErrorCodeEmptyResponseError',
  BidNoContent204Error: 'BidErrorCodeNoContent204Error',
  BidNoFillError: 'BidErrorCodeNoFillError',
  BidEmptyVastError: 'BidErrorCodeEmptyVastError',
  BidVastValidateError: 'BidErrorCodeVastValidateError',
  BidCachePutCacheMiss: 'BidErrorCodeCachePutCacheMiss',
  BidUnwrapTimeoutError: 'BidErrorCodeUnwrapTimeoutError',
  BidPriceBelowFloor: 'BidErrorCodeBidPriceBelowFloor',
  BidUnknownError: 'BidErrorCodeUnknownError',
  BidRejectedUnknown: 'BidErrorCodeBidRejectedUnknown',
  BidRejectedDuration: 'BidErrorCodeBidRejectedDuration',
  BidRejectedDupMediafileUrl: 'BidErrorCodeBidRejectedDupMediafileURL',
  BidRejectedDupAdomain: 'BidErrorCodeBidRejectedDupAdomain',
  BidRejectedDupCategory: 'BidErrorCodeBidRejectedDupCategory',
  BidRejectedCacheId: 'BidErrorCodeBidRejectedCacheID',
  BidRejectedPrice: 'BidErrorCodeBidRejectedPrice',
  BidRejectedAdvertiserBlocklist: 'BidErrorCodeBidRejectedAdvertiserBlocklist',
  BidRejectedIabCatBlocklist: 'BidErrorCodeBidRejectedIABCatBlocklist',
  BidRejectedAdomainMissing: 'BidErrorCodeBidRejectedAdomainMissing',
  BidRejectedAboveMaxAdDuration: 'BidErrorCodeBidRejectedAboveMaxAdDuration',
  BidRejectedBelowMinAdDuration: 'BidErrorCodeBidRejectedBelowMinAdDuration',
  BidNoMediafileSatisfySiteMaxBitrate: 'BidErrorCodeNoMediafileSatisfySiteMaxBitrate',
  BidRejectedPodFloor: 'BidErrorCodeBidRejectedPodFloor',
  BidRejectedAllHouseAds: 'BidErrorCodeBidRejectedAllHouseAds',
  BidRejectedDupAdId: 'BidErrorCodeBidRejectedDupAdID',
  BidRejectedDupCreativeId: 'BidErrorCodeBidRejectedDupCreativeID',
  BidNoMediafileSatisfyEndpointMaxBitrate: 'BidErrorCodeNoMediafileSatisfyEndpointMaxBitrate',
  BidNoMediafileSatisfyEndpointMinBitrate: 'BidErrorCodeNoMediafileSatisfyEndpointMinBitrate',
  BidNoMediafileSatisfySiteMinBitrate: 'BidErrorCodeNoMediafileSatisfySiteMinBitrate',
  BidRejectedBrandSafetyRuleBlock: 'BidErrorCodeBidRejectedBrandSafetyRuleBlock',
  BidRejectedMinPodSizeNotMeet: 'BidErrorCodeBidRejectedMinPodSizeNotMeet',
  BidRejectedDupBidCatExclusion: 'BidErrorCodeBidRejectedDupBidCatExclusion',
  BidRejectedTooManyBidCatExclusion: 'BidErrorCodeBidRejectedTooManyBidCatExclusion',
  BidPriceMissing: 'BidErrorCodeBidPriceMissing',
  BidBidderNotSharedInventory: 'BidErrorCodeBidderNotSharedInventory',
  BidRejectedDupAdomainElea: 'BidErrorCodeBidRejectedDupAdomainElea',
  BidRejectedDupAdomainClickThrough: 'BidErrorCodeBidRejectedDupAdomainClickThrough',
  BidRejectedDupCategoryElea: 'BidErrorCodeBidRejectedDupCategoryElea',
  BidRejectedPriceAboveErrorThreshold: 'BidErrorCodeBidRejectedPriceAboveErrorThreshold',
  BidRejectedDupCampaignId: 'BidErrorCodeBidRejectedDupCampaignID',
  BidRejectedDupApsKey: 'BidErrorCodeBidRejectedDupAPSKey',
  BidRejectedMediafileBlocklist: 'BidErrorCodeBidRejectedMediafileBlocklist',
  BidRejectedNotFirstSlotInPod: 'BidErrorCodeBidRejectedNotFirstSlotInPod',
  BidRejectedDupMediafileUrlNormal: 'BidErrorCodeBidRejectedDupMediafileURLNormal',
  BidRejectedCreativeIdBlock: 'BidErrorCodeBidRejectedCreativeIDBlock',
  BidRejectedNonsecureVast: 'BidErrorCodeBidRejectedNonsecureVAST',
  BidRejectedSlotTargetingMismatch: 'BidErrorCodeBidRejectedSlotTargetingMismatch',
  BidInvalidRequestUrl: 'BidErrorCodeInvalidRequestURL',
  BidRejectedCreativeBlockUnknown: 'BidErrorCodeBidRejectedCreativeBlockUnknown',
  BidRejectedCreativeBlock404NotFound: 'BidErrorCodeBidRejectedCreativeBlock404NotFound',
  BidRejectedCreativeBlockMismatchDuration: 'BidErrorCodeBidRejectedCreativeBlockMismatchDuration',
  BidRejectedCreativeValidationRejected: 'BidErrorCodeBidRejectedCreativeValidationRejected',
  BidRejectedOverOrderFrequencyCap: 'BidErrorCodeBidRejectedOverOrderFrequencyCap',
  BidRejectedOverCampaignFrequencyCap: 'BidErrorCodeBidRejectedOverCampaignFrequencyCap',
  BidSiteLoopError: 'BidErrorCodeBidSiteLoopError',
  BidRejectedBlockedByAdvertiser: 'BidErrorCodeBidRejectedBlockedByAdvertiser',
  BidRejectedAboveSharedPodDuration: 'BidErrorCodeBidRejectedAboveSharedPodDuration',
  BidRejectedTier: 'BidErrorCodeBidRejectedTier',
  BidMaxUnwrapError: 'BidErrorCodeMaxUnwrapError',
  BidRejectedLanguageBlocklist: 'BidErrorCodeBidRejectedLanguageBlocklist',
  BidMissingVastMeta: 'BidErrorCodeBidMissingVastMeta',
  BidXmlSyntaxError: 'BidErrorCodeXMLSyntaxError',
  BidRejectedAdvertiserRuleDoNotAir: 'BidErrorCodeBidRejectedAdvertiserRuleDoNotAir',
  BidRejectedAdvertiserRuleCompetitiveSeparationSelf:
    'BidErrorCodeBidRejectedAdvertiserRuleCompetitiveSeparationSelf',
  BidRejectedAdvertiserRuleCompetitiveSeparationOther:
    'BidErrorCodeBidRejectedAdvertiserRuleCompetitiveSeparationOther',
  BidRejectedDupPhiloAudioIdent: 'BidErrorCodeBidRejectedDupPhiloAudioIdent',
  BidInvalidMediafileDeliveryType: 'BidErrorCodeInvalidMediafileDeliveryType',
  BidRejectedCategoryExclusivity: 'BidErrorCodeBidRejectedCategoryExclusivity',
  BidUnwrapEOFError: 'BidErrorCodeUnwrapEOFError',
  BidRejectedCacheConnection: 'BidErrorCodeBidRejectedCacheConnection',
  BidRejectedCacheXmlEncode: 'BidErrorCodeBidRejectedCacheXMLEncode',
  BidRejectedCacheStore: 'BidErrorCodeBidRejectedCacheStore',
  BidConnectionErrorAlt: 'BidErrorCodeBidConnectionError',
  BidRejectedEventTrackerBlocklist: 'BidErrorCodeBidRejectedEventTrackerBlocklist',
  BidPriceTooHigh: 'BidErrorCodeBidPriceTooHigh',
  BidRejectedCreativeQualityAssurance: 'BidErrorCodeBidRejectedCreativeQualityAssurance',
  BidRejectedPlatformConnectionBidderSlotTargetingMismatch:
    'BidErrorCodeBidRejectedPlatformConnectionBidderSlotTargetingMismatch',
  BidRejectedBelowFloor: 'BidErrorCodeBidRejectedBelowFloor',
  BidCombineCreativeError: 'BidErrorCodeCombineCreativeError',
  BidResponseEofError: 'BidErrorCodeResponseEOFError',
  BidConnectionResetByPeer: 'BidErrorCodeBidConnectionResetByPeer',
  BidGzipReadError: 'BidErrorCodeGzipReadError',
  BidUnwrapParseError: 'BidErrorCodeUnwrapParseError',
  BidMacroReplacementError: 'BidErrorCodeMacroReplacementErrorCode',
  BidOtherUnwrapError: 'BidErrorCodeOtherUnwrapError',
  BidRejectedPrivateAuctionDealIDMismatch: 'BidErrorCodeBidRejectedPrivateAuctionDealIDMismatch',
};

export const campaignNoFillErrorKeyToTKeyMap: Record<CampaignNoFillErrorKey, TKey> = {
  NoFillUndefined: 'CampaignNoFillErrorCodeUndefined',
  EmptyVast: 'CampaignNoFillErrorCodeEmptyVast',
  FrequencyCap: 'CampaignNoFillErrorCodeFrequencyCap',
  Pacing: 'CampaignNoFillErrorCodePacing',
  SiteLoopError: 'CampaignNoFillErrorCodeSiteLoopError',
  EmptyVastMediafile: 'CampaignNoFillErrorCodeEmptyVastMediafile',
  CreativeSelectionError: 'CampaignNoFillErrorCodeCreativeSelectionError',
  ZeroDuration: 'CampaignNoFillErrorCodeZeroDuration',
  AdserverOrderNotFound: 'CampaignNoFillErrorCodeAdserverOrderNotFound',
  LowPacing: 'CampaignNoFillErrorCodeLowPacing',
  OrderFrequencyCap: 'CampaignNoFillErrorCodeOrderFrequencyCap',
  VastTimeout: 'CampaignNoFillErrorCodeVastTimeout',
  EmaPacing: 'CampaignNoFillErrorCodeEmaPacing',
  EmaPacingDataNotFound: 'CampaignNoFillErrorCodeEMAPacingDataNotFound',
};

export const auctionInsightsMiscKeyToTKeyMap: Record<string, TKey> = {
  TotalImpressions: 'Impressions',
};

export const auctionInsightsKeyToTKeyMap: Record<string, TKey> = {
  ...bidErrorKeyToTKeyMap,
  ...campaignNoFillErrorKeyToTKeyMap,
  ...auctionInsightsMiscKeyToTKeyMap,
};

export interface IBidErrorData {
  BidBadServerResponseError: number;
  BidUnknownError: number;
  BidRejectedDupMediafileUrl: number;
  BidPriceBelowFloor: number;
  BidRejectedDupAdomain: number;
  BidRejectedDupMediafileUrlNormal: number;
  BidUnwrapEofError: number;
  BidRejectedIabCatBlocklist: number;
  BidRejectedAboveMaxAdDuration: number;
  BidTimeoutError: number;
  BidBadInputError: number;
  BidFailedToRequestBidsError: number;
  BidAuctionFailed: number;
  BidRateLimitBlocked: number;
  BidFailedToParseResponse: number;
  BidConnectionError: number;
  BidPanic: number;
  BidPrebidError: number;
  BidEmptyResponseError: number;
  BidNoContent204Error: number;
  BidNoFillError: number;
  BidEmptyVastError: number;
  BidVastValidateError: number;
  BidCachePutCacheMiss: number;
  BidUnwrapTimeoutError: number;
  BidRejectedUnknown: number;
  BidRejectedDuration: number;
  BidRejectedDupCategory: number;
  BidRejectedCacheId: number;
  BidRejectedAdvertiserBlocklist: number;
  BidRejectedAdomainMissing: number;
  BidRejectedBelowMinAdDuration: number;
  BidNoMediafileSatisfySiteMaxBitrate: number;
  BidRejectedPodFloor: number;
  BidRejectedAllHouseAds: number;
  BidRejectedDupAdId: number;
  BidRejectedDupCreativeId: number;
  BidNoMediafileSatisfyEndpointMaxBitrate: number;
  BidNoMediafileSatisfyEndpointMinBitrate: number;
  BidNoMediafileSatisfySiteMinBitrate: number;
  BidRejectedBrandSafetyRuleBlock: number;
  BidRejectedMinPodSizeNotMeet: number;
  BidRejectedDupBidCatExclusion: number;
  BidRejectedTooManyBidCatExclusion: number;
  BidPriceMissing: number;
  BidBidderNotSharedInventory: number;
  BidRejectedDupAdomainElea: number;
  BidRejectedDupAdomainClickThrough: number;
  BidRejectedDupCategoryElea: number;
  BidRejectedPriceAboveErrorThreshold: number;
  BidRejectedDupCampaignId: number;
  BidRejectedDupApsKey: number;
  BidRejectedMediafileBlocklist: number;
  BidRejectedNotFirstSlotInPod: number;
  BidRejectedCreativeIdBlock: number;
  BidRejectedNonsecureVast: number;
  BidRejectedSlotTargetingMismatch: number;
  BidInvalidRequestUrl: number;
  BidRejectedCreativeBlockUnknown: number;
  BidRejectedCreativeBlock404NotFound: number;
  BidRejectedCreativeBlockMismatchDuration: number;
  BidRejectedCreativeValidationRejected: number;
  BidRejectedOverOrderFrequencyCap: number;
  BidRejectedOverCampaignFrequencyCap: number;
  BidSiteLoopError: number;
  BidRejectedBlockedByAdvertiser: number;
  BidRejectedAboveSharedPodDuration: number;
  BidMaxUnwrapError: number;
  BidRejectedLanguageBlocklist: number;
  BidMissingVastMeta: number;
  BidXmlSyntaxError: number;
  BidRejectedAdvertiserRuleDoNotAir: number;
  BidRejectedAdvertiserRuleCompetitiveSeparationSelf: number;
  BidRejectedAdvertiserRuleCompetitiveSeparationOther: number;
  BidRejectedDupPhiloAudioIdent: number;
  BidInvalidMediafileDeliveryType: number;
  BidRejectedCategoryExclusivity: number;
  BidRejectedCacheConnection: number;
  BidRejectedCacheXmlEncode: number;
  BidRejectedCacheStore: number;
  BidRejectedEventTrackerBlocklist: number;
  BidPriceTooHigh: number;
  BidRejectedCreativeQualityAssurance: number;
  BidRejectedPlatformConnectionBidderSlotTargetingMismatch: number;
  BidRejectedBelowFloor: number;
  BidCombineCreativeError: number;
  BidResponseEOFError: number;
  BidConnectionResetByPeer: number;
  BidGzipReadError: number;
  BidUnwrapParseError: number;
  BidMacroReplacementError: number;
  BidOtherUnwrapError: number;
  BidRejectedPrivateAuctionDealIDMismatch: number;
}
